<template>
  <el-container style="height: 100%;">
    <el-aside width="200px">
      <div class="brand">
        <img  src="../assets/logo_text.png" class="img">
      </div>
      <el-menu background-color="#282c34" text-color="#fff" active-text-color="#fff" router :default-active="navIndex" :default-openeds="openeds" ref="navMenu" menu-trigger="click" @open="openNav">
        <el-menu-item index="/dashboard"><i class="iconfont icon-home"></i> 后台首页</el-menu-item>
        <template v-for="menu in menus">
          <el-submenu :key="menu.id" v-if="menu.children" :index="`/${menu.url}`">
            <template slot="title"><i v-if="menu.icon" :class="`iconfont ${menu.icon}`"></i> {{ menu.name }}</template>
            <template v-for="submenu in menu.children">
              <el-submenu :key="submenu.id" v-if="submenu.children" :index="`/${submenu.url}`">
                <template slot="title">{{ submenu.name }}</template>
                <el-menu-item v-for="trdmenu in submenu.children" :key="trdmenu.id" :index="`/${trdmenu.url}`">{{ trdmenu.name }}</el-menu-item>
              </el-submenu>
              <el-menu-item :key="submenu.id" v-else :index="`/${submenu.url}`">{{ submenu.name }}</el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item :key="menu.id" v-else :index="`/${menu.url}`"><i v-if="menu.icon" :class="`iconfont ${menu.icon}`"></i> {{ menu.name }}</el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container class="middle-container">
      <el-header height="60px">
        <span>&nbsp;</span>
        <div class="top-bar">
          <div class="user-info">{{user.name}}, <el-button icon="el-icon-switch-button" size="mini" @click="logout"></el-button></div>
        </div>
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
      <el-footer height="30px">
        版权所有 xxx &copy;2025-2026
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'Layout',
  data () {
    return {
      user: {
        name: ''
      },
      menus: [],
      navIndex: '/dashboard',
      openeds: ['/finance', '/system']
    }
  },
  mounted () {
    // document.addEventListener('click', this.handleDocumentClick)
    this.user.name = localStorage.getItem('admin')
    this.getNav()
  },
  beforeDestroy () {
    // document.removeEventListener('click', this.handleDocumentClick)
  },
  methods: {
    getNav () {
      request.get('menus').then(res => {
        if (res.code === 401) {
          this.$router.push('/')
        }
        this.menus = res.data
      })
    },
    logout () {
      localStorage.removeItem('admin')
      localStorage.removeItem('token')
      this.$router.push('/')
    },
    openNav (idx) {
      this.navIndex = idx
      console.log(idx)
    },
    handleDocumentClick (event) {
      const menu = this.$refs.navMenu
      // 判断点击目标是否在菜单内
      if (!menu.$el.contains(event.target)) {
        console.log(this.navIndex)
        // 关闭所有打开的submenu
        menu.close(this.navIndex)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  height: 100%;
  .el-menu {
      height: calc(100% - 60px);
      overflow-x: hidden;
      overflow-y: auto;
    }
}
.el-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 0;
}
.el-header::after{
  display: block;
  content: "";
  width: 100%;
  height: 1px;
  background-color: #ddd;
  z-index: 999;
  position: absolute;
  bottom: 0;
  left: 0;
}
.brand {
  height: 60px;
  line-height: 60px;
  width: 200px;
  background-color: #282c34;
  .img {
    max-width: 100%;
    max-height: 100%;
  }
}
.top-bar{
  float: right;
}
.el-main {
  padding: 0;
  height: calc(100vh - 90px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-footer {
  line-height: 30px;
  text-align: center;
  position: relative;
}
.el-footer::after{
  display: block;
  content: "";
  width: 100%;
  height: 1px;
  background-color: #ddd;
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
}
.el-menu--horizontal {
  .el-submenu {
    .el-submenu__title {
      line-height: 32px;
      height: 32px;
    }
  }
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>
